import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MenuItemWrapper } from '../menu-utils/menu-utils';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ds-menu-link-item',
    imports: [RouterLink],
    template: `<li
      class="ds-menu-item"
      [attr.aria-current]="$_isSelected() ? 'true' : null"
    >
      <a class="ds-menu-item"
        [target]="$target()"
        [attr.href]="$target() !== '_self' ? $href() : null"
        [routerLink]="$target() === '_self' ? $href() : null">
        <ng-content></ng-content>
      </a>
    </li>`
})
export class MenuLinkItemComponent extends MenuItemWrapper {
  $target = input<string>('_blank', { alias: 'target' });
  $href = input<string | null>(null, { alias: 'href' });
}
